/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface LoginRequest {
  email: string;
  /**
     * @minLength 1
     * @maxLength 128
     */
  password: string;
  comet_token?: string | null;
  fingerprint_event_id?: string | null;
}
